import React, { Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import { Layout } from 'antd'
import { pathOr } from 'ramda'
import useTitle from '@/hooks/useTitle'
import ErrorBoundary from '@/components/ErrorBoundary'
import Loading from '@/components/Loading'
import Exception from '@/components/Exception'
import { AlarmProvider } from '@/hooks/useAlarmDrawer'
import useApp from '@/hooks/useApp'
import { useLocale, locales } from '@/hooks/useLocale'
import useRoutes from 'src/hooks/useRoutes'
import Dashboard from 'src/containers/Dashboard'
import AppHeader from 'src/components/AppHeader'
import SideMenu from 'src/components/SideMenu'
import Login from 'src/containers/Login'
import GlobalStyles from './GlobalStyles'
import { useQueryWebSetting } from '@/graphql/setting'

function App() {
  const routes = useRoutes()
  const { i18n } = useTranslation()

  const { isAuthenticated, isMobile, layoutStyle, renderRoute } = useApp()
  const { setLocale } = useLocale()
  const { web } = useQueryWebSetting()
  useTitle(web.name || '')

  React.useEffect(() => {
    if (web.language) {
      i18n.changeLanguage(web.language)
      setLocale(pathOr(null, [web.language], locales))
    }
  }, [web.language]) // eslint-disable-line

  return (
    <ErrorBoundary>
      <AlarmProvider>
        <GlobalStyles />
        {!isAuthenticated && (
          <Layout>
            <Login />
          </Layout>
        )}
        {isAuthenticated && (
          <Layout style={layoutStyle(isMobile)}>
            <AppHeader />
            <Layout className={cx('bg-greyF9')}>
              <SideMenu />
              <Layout.Content>
                <Suspense fallback={<Loading />}>
                  <Switch>
                    <Route exact path="/" component={Dashboard} />
                    {renderRoute({ data: routes })}
                    <Route component={Exception} />
                  </Switch>
                </Suspense>
              </Layout.Content>
            </Layout>
          </Layout>
        )}
      </AlarmProvider>
    </ErrorBoundary>
  )
}

export default React.memo(App)
